/**
 * What the platform will charge on a price the vendor has not saved yet.
 *
 * The fee used to appear only once a product existed: type a price, save, then
 * discover from the listing that shoppers are charged 10% more. On a marketplace
 * where vendors compete on the customer-facing number, learning it after committing
 * is backwards — so the forms ask for it while the vendor is still typing.
 */
import { api } from '@/lib/api';

export type FeePreview = {
  vertical: 'FOOD' | 'PHARMACY';
  category: string;
  /** False when no fee is set for the category — the vendor keeps the whole price. */
  has_fee: boolean;
  mode: 'RATE' | 'FLAT' | null;
  rate_pct: number | null;
  amount_inr: number | null;
  /** Present only when a price was supplied. */
  preview?: {
    vendor_price_inr: string;
    mrp_inr: string | null;
    platform_fee_inr: string;
    customer_price_inr: string;
    commission_mode: 'RATE' | 'FLAT';
    commission_rate_pct: number | null;
    commission_source: 'VARIANT' | 'PRODUCT' | 'CATEGORY' | 'NONE';
    exceeds_mrp: boolean;
  };
};

export async function fetch_fee_preview(params: {
  vertical: 'FOOD' | 'PHARMACY';
  category: string;
  price_inr?: number;
  mrp_inr?: number;
}): Promise<FeePreview> {
  const res = await api.get<FeePreview>('/vendor/commission/preview', { params });
  return res.data;
}
